import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

import 'fire-iot-ui-template/src/styles/variables.scss'
import 'fire-iot-ui-template/dist/style.css'
import './styles/mobile.scss'

// 钉钉 H5 微应用四端调试工具：仅在移动端路由下注入一次
if (typeof window !== 'undefined' && window.location.pathname.startsWith('/mobile')) {
  const debugScriptId = 'dingtalk-h5-remote-debug'
  if (!document.getElementById(debugScriptId)) {
    const script = document.createElement('script')
    script.id = debugScriptId
    script.src = 'https://g.alicdn.com/code/npm/@ali/dingtalk-h5-remote-debug/0.1.3/index.js'
    script.async = true
    document.head.appendChild(script)
  }
}

const app = createApp(App)
app.use(createPinia())
app.use(router)

// 应用启动时主动校验一次登录状态，过期 token 会自动清理
const auth = useAuthStore()
auth.validateSession()

app.mount('#app')
